export default "__VITE_ASSET__CT$4ojRe__"